import React from "react";
import {Layout} from "../../global/Table/TablePageHelpers/LayoutObject";
import {
  PRICING_DASHBOARD_PAGE_NAME,
  REFRESH_PRICING,
  PRICING_DASHBOARD_TABLE_PAGINATION_LABEL,
  PRICING_DASHBOARD_TABLE_CELLS, SKU_FILTER_NAMES, PRICING_DASHBOARD_PAGES, SHOW_REPRICING_FILTER_NAMES,
} from '../constants';
import withShipment from "../../../withShipment";
import './PricingDashboardTable.css';
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import RefreshIcon from "@material-ui/icons/Refresh";
import TablePage from "../../global/Table/TablePage";
import {
  availableLocationsSelector,
  marketplacesSelector,
  packagesSelector,
  pricingListingsSelector,
  salesDataSelector,
} from '../../../redux/selectors/settings';
import PricingDashboardTableRow from "./PricingDashboardTableRow";
import {
  fetchPricingListings,
  fetchAmazonListingsPrice,
  getSalesData,
  listPackages, fetchPackageDetailsWithCosts, fetchBoxAndShippingCost, listAvailableLocations,
} from '../../../redux/actions/settings';
import {pricingDashboardLoadingSelector} from "../../../redux/selectors/global";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import {Filter} from "../../global/Table/TablePageHelpers/FilterObject";
import PropTypes from "prop-types";
import { allShortcodesSelector, manufacturersSelector } from '../../../redux/selectors/inventory';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import {Tooltip} from "@material-ui/core";
import InfoIcon from '@material-ui/icons/Info';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import { userInfoSelector } from '../../../redux/selectors/auth';
import { automationInfoSelector } from '../../../redux/selectors/account';
import { getCompany } from '../../../redux/actions/automationRules';
import { getAllProductInventory } from '../../../redux/actions/inventory';

class PricingDashboardTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableEvents: [],
      listingIdBeingEdited: '',
      marketplaceOptions: this.props.marketplaces
        ? this.props.marketplaces.map(
            (marketplace) => marketplace.marketplaceName
          )
        : [],
      brandOptions: this.props.manufacturers ? this.props.manufacturers : [],
      expandedRows: false,
      shortcodeOptions: []
    };
  }

  componentDidMount() {
   this.props.listPackages()
   this.props.getCompany();
   this.props.getAllProductInventory()
   this.props.listAvailableLocations()
  }

  componentDidUpdate(
    prevProps: Readonly<P>,
    prevState: Readonly<S>,
    snapshot: SS
  ) {
    if (
      prevProps.marketplaces !== this.props.marketplaces &&
      this.props.marketplaces
    ) {
      let newMarketplaceOptions;

      newMarketplaceOptions = this.props.marketplaces.map((marketplace) => {
        return marketplace.marketplaceName;
      });
      this.setState({
        marketplaceOptions: newMarketplaceOptions,
      });
    }
    if (
      prevProps.manufacturers !== this.props.manufacturers &&
      this.props.manufacturers
    ) {
      let newbrandOptions;

      newbrandOptions = this.props.manufacturers.map((manufacturers) => {
        return manufacturers;
      });
      this.setState({
        brandOptions: newbrandOptions,
      });
    }
    if (this.props.pricingDashboardLoading) {
      this.props.setCurrentPage(PRICING_DASHBOARD_PAGES.LOADING);
    }

    if (prevProps.allShortcodes !== this.props.allShortcodes && this.props.allShortcodes) {
          const shortcodes = Array.from(
            new Set(
              this.props.allShortcodes
                .map(item => item.shortcode)
                .filter(Boolean)
            )
          ).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

          this.setState({
            shortcodeOptions: shortcodes,
          });
    }

  }

  getTableHeaders = () => {
    let headers = [];
    headers.push(Layout.columnHead(null, null, null));
    PRICING_DASHBOARD_TABLE_CELLS.forEach((headCell) => {
      headers.push(Layout.columnHead(headCell.label, headCell.id, 'left'));
    });
    return headers;
  };

  handleRefresh = () => {
    this.props.fetchAmazonListingsPrice();
  };

  toggleExpandedRows = () => {
    const nextExpanded = !this.state.expandedRows;
    const isEmpty =
      !this.props.salesData || Object.keys(this.props.salesData).length === 0;

    if (nextExpanded && isEmpty) {
      this.props.getSalesData();
    }
    this.setState({ expandedRows: nextExpanded });
  };

  getSearchStrings = (row) => {
    let searchStrings = [];
    if (row.price) searchStrings.push(row.price);
    if (row.shortcode) searchStrings.push(row.shortcode);
    if (row.sku) searchStrings.push(row.sku);
    if (row.asin) searchStrings.push(row.asin);
    if (row.marketplaces[0]) searchStrings.push(row.marketplaces[0]);
    if (row.brand) searchStrings.push(row.brand);
    if (row.relatedProductsAsins) searchStrings.push(row.relatedProductsAsins);

    return searchStrings;
  };

  getTableRow = (row, getRowState, setRowState) => {
    return (
      <PricingDashboardTableRow
        packages={this.props.packages}
        row={row}
        getRowState={getRowState}
        setRowState={setRowState}
        setCurrentPage={this.props.setCurrentPage}
        listingIdBeingEdited={this.state.listingIdBeingEdited}
        matchLocations={this.getLocationName}
        setListingIdBeingEdited={(newId) =>
          this.setState({ listingIdBeingEdited: newId })
        }
        expandedRows={this.state.expandedRows}
        salesData={this.props.salesData}
        fetchPackageDetailsWithCosts={this.props.fetchPackageDetailsWithCosts}
        fetchBoxAndShippingCost={this.props.fetchBoxAndShippingCost}
        user={this.props.userInfo}
        automationSettings={this.props.automationSettings}
      />
    );
  };

  getLocationName = (shipAddressId) => {
        const matchedLocation = this.props.availableLocations.find(loc => loc.shipAddressId === shipAddressId);
        return matchedLocation ? matchedLocation.name : "";
  }

  render() {
    const locationOptions = [
            ...this.props.availableLocations.map(location => location.name)
    ]

    return (
      <React.Fragment>
        <ErrorFeedbackBar />
        <TopToolbar
          pageName={PRICING_DASHBOARD_PAGE_NAME}
          menuItems={[
            {
              title: REFRESH_PRICING,
              icon: <RefreshIcon />,
              onClick: () => {
                this.handleRefresh();
              },
            },
          ]}
        />
        <TablePage
          tableName="PricingDashboardTable"
          eventsVariable={this.state.tableEvents}
          setEventsVariable={(newState) => {
            this.setState({ tableEvents: newState });
          }}
          tableColumnHeads={this.getTableHeaders()}
          tableRows={this.props.tableRows}
          rowFetcher={(filters) => {
            this.props.fetchPricingListings();
          }}
          tableRow={(row, index, getRowState, setRowState) =>
            this.getTableRow(row, getRowState, setRowState)
          }
          getRowId={(row) => row.webstoreProductId}
          onRowDoubleClick={(row) =>
            this.setState({ listingIdBeingEdited: row.webstoreProductId })
          }
          paginationText={PRICING_DASHBOARD_TABLE_PAGINATION_LABEL}
          hasSearchField
          searchStrings={this.getSearchStrings}
          toggleExpandedRows={this.toggleExpandedRows}
          expandedRows={this.state.expandedRows}
          filters={[
            Filter.createFilter(
              'marketplace',
              (row) => row.marketplaces,
              null,
              Filter.relations.containsMemberOf,
              true
            ),
            Filter.createFilter("location",
            (row) => this.getLocationName(row.shipAddressId),
            null,
             Filter.relations.containedBy,
            true),
            Filter.createFilter(
              'brand',
              (row) => row.brand,
              null,
              Filter.relations.containedBy,
              true
            ),
            Filter.createFilter(
              'shortcode',
              (row) => row.shortcode,
              null,
              Filter.relations.containedBy,
              true
            ),
            Filter.createFilter(
              SKU_FILTER_NAMES.SINGLE_BUY_BOX_WINNER,
              (row) => !row.isBuyBoxWinner || row.has2BuyBoxWinners,
              false,
              Filter.relations.equals,
              false
            ),
            Filter.createFilter(
              SKU_FILTER_NAMES.TWO_BUY_BOX_WINNERS,
              (row) => !row.isBuyBoxWinner || !row.has2BuyBoxWinners,
              false,
              Filter.relations.equals,
              false
            ),

            Filter.createFilter(
              SHOW_REPRICING_FILTER_NAMES.SHOW_REPRICING_ON,
              (row) => !row.repricing,
              false,
              Filter.relations.equals,
              false
            ),

            Filter.createFilter(
              SHOW_REPRICING_FILTER_NAMES.SHOW_REPRICING_OFF,
              (row) => row.repricing,
              false,
              Filter.relations.equals,
              false
            ),

          ]}
          filterCheckboxes={[
            Layout.checkBox(
              SKU_FILTER_NAMES.SINGLE_BUY_BOX_WINNER,
              <div>
                show
                <ThumbUpAltIcon
                  style={{ marginBottom: 5, marginLeft: 2, color: 'black' }}
                />
                <Tooltip title="show listing that has 1 buy box winner">
                  <InfoIcon
                    style={{ marginLeft: 4, fontSize: 'medium', color: 'gray' }}
                  />
                </Tooltip>
              </div>,
              <CheckBoxIcon style={{ color: '#acd685' }} />,
              <CheckBoxOutlineBlankOutlinedIcon style={{ color: 'gray' }} />
            ),
            Layout.checkBox(
              SKU_FILTER_NAMES.TWO_BUY_BOX_WINNERS,
              <div>
                show
                <ThumbUpAltIcon
                  style={{ marginBottom: 5, marginLeft: 2, color: 'gray' }}
                />
                <Tooltip title="show listing that has 2 buy box winners">
                  <InfoIcon
                    style={{ marginLeft: 4, fontSize: 'medium', color: 'gray' }}
                  />
                </Tooltip>
              </div>,
              <CheckBoxIcon style={{ color: '#acd685' }} />,
              <CheckBoxOutlineBlankOutlinedIcon style={{ color: 'gray' }} />
            ),


            Layout.checkBox(
              SHOW_REPRICING_FILTER_NAMES.SHOW_REPRICING_ON,
              <div>
                 Show repricing on
              </div>,
              <CheckBoxIcon style={{ color: '#acd685' }} />,
              <CheckBoxOutlineBlankOutlinedIcon style={{ color: 'gray' }} />
            ),
           Layout.checkBox(
              SHOW_REPRICING_FILTER_NAMES.SHOW_REPRICING_OFF,
              <div>
               Show repricing off
              </div>,
              <CheckBoxIcon style={{ color: '#acd685' }} />,
              <CheckBoxOutlineBlankOutlinedIcon style={{ color: 'gray' }} />
            ),


          ]}
          filterDropdown={Layout.newLayout(2, [
            Layout.row([
              Layout.rowElement(
                1,
                'marketplace',
                'Marketplace',
                Layout.elementStyle.checkboxDropdown,
                this.state.marketplaceOptions
              ),
              Layout.rowElement(1,
              "location",
              "Location",
              Layout.elementStyle.checkboxDropdown,
              locationOptions)
            ]),
            Layout.row([
              Layout.rowElement(
                1,
                'brand',
                'Brand',
                Layout.elementStyle.checkboxDropdown,
                (this.state.brandOptions || [])
                .filter(brand => brand && brand !== "-")
                .sort((a, b) => a.localeCompare(b))
              ),
                Layout.rowElement(
                1,
                'shortcode',
                'Shortcode',
                Layout.elementStyle.checkboxDropdown,
                this.state.shortcodeOptions
              ),

            ]),
          ])}
        />
      </React.Fragment>
    );
  }
}

PricingDashboardTable.defaultProps = {
    tableRows: [],
    manufacturers: [],
}

PricingDashboardTable.propTypes = {
    manufacturers: PropTypes.array,
}

const mapStateToProps = (state) => ({
    tableRows: pricingListingsSelector(state),
    pricingDashboardLoading: pricingDashboardLoadingSelector(state),
    marketplaces: marketplacesSelector(state),
    manufacturers: manufacturersSelector(state),
    salesData: salesDataSelector(state),
    packages: packagesSelector(state),
    userInfo: userInfoSelector(state),
    automationSettings: automationInfoSelector(state),
    allShortcodes: allShortcodesSelector(state),
    availableLocations: availableLocationsSelector(state),
})
const actionCreators = {
    fetchPricingListings,
    fetchAmazonListingsPrice,
    getSalesData,
    listPackages,
    fetchPackageDetailsWithCosts,
    fetchBoxAndShippingCost,
    getCompany,
    getAllProductInventory,
    listAvailableLocations
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, PricingDashboardTable);